import { RES_LOAD, RES_UPDATE } from './actionType';
import {
    acc_distr_groups,
    admin_groups,
    clinics,
    countries,
    distr_groups,
    form_download,
    groups,
    knowledge_base_article,
    knowledge_base_video,
    promotionCountry,
    stateProvinces,
} from './type';

/**
 * @typedef {Object} RescourceState
 * @property {boolean} isInit
 * @property {acc_distr_groups} acc_distr_groups
 * @property {admin_groups} admin_groups
 * @property {clinics} clinics
 * @property {countries} countries
 * @property {distr_groups} distr_groups
 * @property {form_download} form_download
 * @property {groups} groups
 * @property {knowledge_base_article} knowledge_base_article
 * @property {knowledge_base_video} knowledge_base_video
 * @property {promotionCountry} promotionCountry
 * @property {stateProvinces} stateProvinces
 */

export const RescourceState = {};

const initialState = {
    isInit: false,
    countries: [],
    stateProvinces: {},
    stateProvincesList: [],
    clinics: {},
    groups: {},
    distr_groups: {},
    form_download: {},
    knowledge_base_article: {},
    knowledge_base_video: {},
    promotionCountry: {},
    admin_groups: {},
    acc_distr_groups: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RES_LOAD:
            return {
                ...initialState,
                isInit: true,
                ...action.payload,
            };
        case RES_UPDATE:
            return {
                ...state,
                isInit: true,
                ...action.payload,
            };
        default:
            return state;
    }
};
